import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getAddresStyles = (theme: Theme): SerializedStyles =>
    css({
        flex: '1 1 50%',
        marginBottom: theme.spacing(2),
        [theme.mediaQuery('tabletLarge')]: {
            marginBottom: 0,
        },
    });

export const getListAddresStyles = {
    listStyle: 'none',
};

export const getAddressErrorStyles = (theme: Theme): SerializedStyles =>
    css({
        color: theme.palette.error.main,
        fontStyle: 'italic',
    });
